import { Route } from 'react-router';
import { getOpcoOrganizationUsersPath } from '../path/path';
import { OrganizationDetailsPage } from '../OrganizationDetailsPage';
import { OrganizationUserDetailsPage } from '../Details/OrganizationUserDetailsPage';
import { getOrganizationUserDetailsPath } from '../Details/path/path';

export const OrganizationRoutes = [
  <Route
    key={getOpcoOrganizationUsersPath()}
    path={getOpcoOrganizationUsersPath()}
    element={<OrganizationDetailsPage />}
  />,
  <Route
    key={getOrganizationUserDetailsPath()}
    path={getOrganizationUserDetailsPath()}
    element={<OrganizationUserDetailsPage />}
  />,
];
